import React from 'react'

const NotFound = () => {
    return (
        <div className='container'>
            <h3>PAGE NOT FOUND</h3>
        </div>
    )
}

export default NotFound